export default "__VITE_ASSET__af78fe3d__"